import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getPossibleReserveDatesLoading: false,
  getPossibleReserveDatesFailed: false,
  getPossibleReserveDatesReject: false,
  getPossibleReserveDatesMessage: [],
  possibleDatesAndTimes: [],
  cafeData: [],
  possibleDates: [],
  possibleReserveTypes: [],
  reserveDate: '',

  getPossibleReserveTablesLoading: false,
  getPossibleReserveTablesFailed: false,
  getPossibleReserveTablesReject: false,
  getPossibleReserveTablesMessage: [],
  possibleTables: [],
  cafeTablesLocation:'',


  createNewReserveLoading: false,
  createNewReserveFailed: false,
  createNewReserveReject: false,
  createNewReserveMessage: [],
  NewReserve: [],

  cancelReserveLoading: false,
  cancelReserveFailed: false,
  cancelReserveReject: false,
  cancelReserveMessage: [],

  reservePaymentLoading: false,
  reservePaymentFailed: false,
  reservePaymentReject: false,
  reservePaymentMessage: [],
  reservePaymentToken: [],

  getMyReservesLoading: false,
  getMyReservesFailed: false,
  getMyReservesReject: false,
  getMyReservesMessage: [],
  MyReserves: [],

  getMyReserveDetailsLoading: false,
  getMyReserveDetailsFailed: false,
  getMyReserveDetailsReject: false,
  getMyReserveDetailsMessage: [],
  MyReserveDetails: [],

  cancelPaidReserveLoading: false,
  cancelPaidReserveFailed: false,
  cancelPaidReserveReject: false,
  cancelPaidReserveMessage: [],

  applyDiscountCodeLoading: false,
  applyDiscountCodeFailed: false,
  applyDiscountCodeReject: false,
  applyDiscountCodeMessage: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_POSSIBLE_RESERVE_DATES_LOADING: {
      return {
        ...state,
        getPossibleReserveDatesLoading: true,
        getPossibleReserveDatesFailed: false,
        getPossibleReserveDatesReject: false,
        getPossibleReserveDatesMessage: [],
        possibleDatesAndTimes: [],
        cafeData: [],
        possibleReserveTypes: [],
      };
    }
    case actionTypes.GET_POSSIBLE_RESERVE_DATES_SUCCESS: {
      return {
        ...state,
        getPossibleReserveDatesLoading: false,
        getPossibleReserveDatesFailed: false,
        getPossibleReserveDatesReject: false,
        getPossibleReserveDatesMessage: [],
        possibleDatesAndTimes: action.payload.possibleDatesAndTimes,
        cafeData: action.payload.cafe,
        possibleReserveTypes: action.payload.possibleReserveTypes,
      };
    }
    case actionTypes.GET_POSSIBLE_RESERVE_DATES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getPossibleReserveDatesLoading: false,
        getPossibleReserveDatesFailed: true,
        getPossibleReserveDatesReject: false,
        getPossibleReserveDatesMessage: message,
        possibleDatesAndTimes: [],
        cafeData: [],
        possibleReserveTypes: [],
      };
    }
    case actionTypes.GET_POSSIBLE_RESERVE_DATES_REJECT: {
      return {
        ...state,
        getPossibleReserveDatesLoading: false,
        getPossibleReserveDatesFailed: false,
        getPossibleReserveDatesReject: true,
        getPossibleReserveDatesMessage: [],
        possibleDatesAndTimes: [],
        cafeData: [],
        possibleReserveTypes: [],
      };
    }

    case actionTypes.GET_POSSIBLE_RESERVE_TABLES_LOADING: {
      return {
        ...state,
        getPossibleReserveTablesLoading: true,
        getPossibleReserveTablesFailed: false,
        getPossibleReserveTablesReject: false,
        getPossibleReserveTablesMessage: [],
        possibleTables: [],
        cafeTablesLocation: '',
      };
    }
    case actionTypes.GET_POSSIBLE_RESERVE_TABLES_SUCCESS: {
      return {
        ...state,
        getPossibleReserveTablesLoading: false,
        getPossibleReserveTablesFailed: false,
        getPossibleReserveTablesReject: false,
        getPossibleReserveTablesMessage: [],
        possibleTables: action.payload.possibleTables,
        cafeTablesLocation: action.payload.locationTableUrl,
      };
    }
    case actionTypes.GET_POSSIBLE_RESERVE_TABLES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getPossibleReserveTablesLoading: false,
        getPossibleReserveTablesFailed: true,
        getPossibleReserveTablesReject: false,
        getPossibleReserveTablesMessage: message,
        possibleTables: [],
        cafeTablesLocation: '',
      };
    }
    case actionTypes.GET_POSSIBLE_RESERVE_TABLES_REJECT: {
      return {
        ...state,
        getPossibleReserveTablesLoading: false,
        getPossibleReserveTablesFailed: false,
        getPossibleReserveTablesReject: true,
        getPossibleReserveTablesMessage: [],
        possibleTables: [],
        cafeTablesLocation: '',
      };
    }

    case actionTypes.CREATE_NEW_RESERVE_LOADING: {
      return {
        ...state,
        createNewReserveLoading: true,
        createNewReserveFailed: false,
        createNewReserveReject: false,
        createNewReserveMessage: [],
        NewReserve: [],
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.CREATE_NEW_RESERVE_SUCCESS: {
      return {
        ...state,
        createNewReserveLoading: false,
        createNewReserveFailed: false,
        createNewReserveReject: false,
        createNewReserveMessage: [],
        NewReserve: action.payload,
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.CREATE_NEW_RESERVE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createNewReserveLoading: false,
        createNewReserveFailed: true,
        createNewReserveReject: false,
        createNewReserveMessage: message,
        NewReserve: [],
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.CREATE_NEW_RESERVE_REJECT: {
      // const { message } = action.payload;
      return {
        ...state,
        createNewReserveLoading: false,
        createNewReserveFailed: false,
        createNewReserveReject: true,
        createNewReserveMessage: [],
        NewReserve: [],
        applyDiscountCodeMessage: [],
      };
    }

    case actionTypes.CANCEL_RESERVE_LOADING: {
      return {
        ...state,
        cancelReserveLoading: true,
        cancelReserveFailed: false,
        cancelReserveReject: false,
        cancelReserveMessage: [],
      };
    }
    case actionTypes.CANCEL_RESERVE_SUCCESS: {
      return {
        ...state,
        cancelReserveLoading: false,
        cancelReserveFailed: false,
        cancelReserveReject: false,
        cancelReserveMessage: [],
      };
    }
    case actionTypes.CANCEL_RESERVE_FAILED: {
      return {
        ...state,
        cancelReserveLoading: false,
        cancelReserveFailed: true,
        cancelReserveReject: false,
        cancelReserveMessage: [],
      };
    }
    case actionTypes.CANCEL_RESERVE_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        cancelReserveLoading: false,
        cancelReserveFailed: false,
        cancelReserveReject: true,
        cancelReserveMessage: message,
      };
    }

    case actionTypes.RESERVE_PAYMENT_LOADING: {
      return {
        ...state,
        reservePaymentLoading: true,
        reservePaymentFailed: false,
        reservePaymentReject: false,
        reservePaymentMessage: [],
        reservePaymentToken: [],
      };
    }
    case actionTypes.RESERVE_PAYMENT_SUCCESS: {
      return {
        ...state,
        reservePaymentLoading: false,
        reservePaymentFailed: false,
        reservePaymentReject: false,
        reservePaymentMessage: [],
        reservePaymentToken: action.payload,
      };
    }
    case actionTypes.RESERVE_PAYMENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        reservePaymentLoading: false,
        reservePaymentFailed: true,
        reservePaymentReject: false,
        reservePaymentMessage: message,
        reservePaymentToken: [],
      };
    }
    case actionTypes.RESERVE_PAYMENT_REJECT: {
      return {
        ...state,
        reservePaymentLoading: false,
        reservePaymentFailed: false,
        reservePaymentReject: true,
        reservePaymentMessage: [],
        reservePaymentToken: [],
      };
    }

    case actionTypes.GET_MY_RESERVES_LOADING: {
      return {
        ...state,
        getMyReservesLoading: true,
        getMyReservesFailed: false,
        getMyReservesReject: false,
        getMyReservesMessage: [],
        MyReserves: [],
      };
    }
    case actionTypes.GET_MY_RESERVES_SUCCESS: {
      return {
        ...state,
        getMyReservesLoading: false,
        getMyReservesFailed: false,
        getMyReservesReject: false,
        getMyReservesMessage: [],
        MyReserves: action.payload.reserves,
      };
    }
    case actionTypes.GET_MY_RESERVES_FAILED: {
      return {
        ...state,
        getMyReservesLoading: false,
        getMyReservesFailed: true,
        getMyReservesReject: false,
        getMyReservesMessage: [],
        MyReserves: [],
      };
    }
    case actionTypes.GET_MY_RESERVES_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getMyReservesLoading: false,
        getMyReservesFailed: false,
        getMyReservesReject: true,
        getMyReservesMessage: message,
        MyReserves: [],
      };
    }

    case actionTypes.GET_MY_RESERVE_DETAILS_LOADING: {
      return {
        ...state,
        getMyReserveDetailsLoading: true,
        getMyReserveDetailsFailed: false,
        getMyReserveDetailsReject: false,
        getMyReserveDetailsMessage: [],
        MyReserveDetails: [],
      };
    }
    case actionTypes.GET_MY_RESERVE_DETAILS_SUCCESS: {
      return {
        ...state,
        getMyReserveDetailsLoading: false,
        getMyReserveDetailsFailed: false,
        getMyReserveDetailsReject: false,
        getMyReserveDetailsMessage: [],
        MyReserveDetails: action.payload,
      };
    }
    case actionTypes.GET_MY_RESERVE_DETAILS_FAILED: {
      return {
        ...state,
        getMyReserveDetailsLoading: false,
        getMyReserveDetailsFailed: true,
        getMyReserveDetailsReject: false,
        getMyReserveDetailsMessage: [],
        MyReserveDetails: [],
      };
    }
    case actionTypes.GET_MY_RESERVE_DETAILS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getMyReserveDetailsLoading: false,
        getMyReserveDetailsFailed: false,
        getMyReserveDetailsReject: true,
        getMyReserveDetailsMessage: message,
        MyReserveDetails: [],
      };
    }

    case actionTypes.CANCEL_PAID_RESERVE_LOADING: {
      return {
        ...state,
        cancelPaidReserveLoading: true,
        cancelPaidReserveFailed: false,
        cancelPaidReserveReject: false,
        cancelPaidReserveMessage: [],
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.CANCEL_PAID_RESERVE_SUCCESS: {
      return {
        ...state,
        cancelPaidReserveLoading: false,
        cancelPaidReserveFailed: false,
        cancelPaidReserveReject: false,
        cancelPaidReserveMessage: action.payload,
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.CANCEL_PAID_RESERVE_FAILED: {
      return {
        ...state,
        cancelPaidReserveLoading: false,
        cancelPaidReserveFailed: true,
        cancelPaidReserveReject: false,
        cancelPaidReserveMessage: [],
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.CANCEL_PAID_RESERVE_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        cancelPaidReserveLoading: false,
        cancelPaidReserveFailed: false,
        cancelPaidReserveReject: true,
        cancelPaidReserveMessage: message,
      };
    }

    case actionTypes.APPLY_DISCOUNT_CODE_LOADING: {
      return {
        ...state,
        applyDiscountCodeLoading: true,
        applyDiscountCodeFailed: false,
        applyDiscountCodeReject: false,
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.APPLY_DISCOUNT_CODE_SUCCESS: {
      return {
        ...state,
        applyDiscountCodeLoading: false,
        applyDiscountCodeFailed: false,
        applyDiscountCodeReject: false,
        applyDiscountCodeMessage: [],
      };
    }
    case actionTypes.APPLY_DISCOUNT_CODE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        applyDiscountCodeLoading: false,
        applyDiscountCodeFailed: true,
        applyDiscountCodeReject: false,
        applyDiscountCodeMessage: message,
      };
    }
    case actionTypes.APPLY_DISCOUNT_CODE_REJECT: {
      return {
        ...state,
        applyDiscountCodeLoading: false,
        applyDiscountCodeFailed: false,
        applyDiscountCodeReject: true,
        applyDiscountCodeMessage: [],
      };
    }

    default:
      return state;
  }
};
